module.exports = __webpack_public_path__ + "static/media/p6.a7113977.png";